module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2z"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1"
    }
  }, [_vm._v("1 An Invitation to Israel Literacy")]), _vm._v(" "), _c('em', [_vm._v("/ S. Ilan Troen, and Rachel Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ch2"
    }
  }, [_vm._v("2 Israel: Geography, Demography, and Economy")]), _vm._v(" "), _c('em', [_vm._v("/ S. Ilan Troen, Maoz Azaryahu, and Arnon Golan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03#ch3"
    }
  }, [_vm._v("3 From Zionism to Zion")]), _vm._v(" "), _c('em', [_vm._v("/ Michael Brenner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Zionist Settlement in the Land of Israel/Palestine")]), _vm._v(" "), _c('em', [_vm._v("/ S. Ilan Troen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Arab-Israeli Conflict")]), _vm._v(" "), _c('em', [_vm._v("/ Alan Dowty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 History of the Peace Process")]), _vm._v(" "), _c('em', [_vm._v("/ David Makovsky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Israel in World Opinion")]), _vm._v(" "), _c('em', [_vm._v("/ Gil Troy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Israel: A Jewish Democracy")]), _vm._v(" "), _c('em', [_vm._v("/ Yedidia Stern")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Citizenship and Democracy in Israel")]), _vm._v(" "), _c('em', [_vm._v("/ Donna Robinson Divine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Israel, American Jews, and Jewish Peoplehood")]), _vm._v(" "), _c('em', [_vm._v("/ Steven Bayme")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 “Jewishness” in Israel: Israel as a Jewish State")]), _vm._v(" "), _c('em', [_vm._v("/ David Ellenson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Contemporary Christianity and Israel")]), _vm._v(" "), _c('em', [_vm._v("/ Yaakov Ariel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Perceptions and Understandings of Israel within Islam")]), _vm._v(" "), _c('em', [_vm._v("/ Norman Stillman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 “Hebrewism” and Israeli Culture")]), _vm._v(" "), _c('em', [_vm._v("/ Rachel S. Harris")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Israeli and Hebrew Literature: from the Yishuv to the 21st Century")]), _vm._v(" "), _c('em', [_vm._v("/ Ranen Omer-Sherman")])]), _vm._v(" "), _c('p', {
    staticClass: "tocat"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary#glo",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('em', [_vm._v("/ Carol Troen")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/timeline#tim",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TIMELINE:")]), _vm._v(" "), _c('em', [_vm._v("A Century of Wars and Conflict and Peace Negotiations and Agreements 1917-2016")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0